import { type Common } from '../common.js';
import {
  type PopulatedAssistantDefinition,
  type UpdateValues,
} from '../models/assistant/assistantDefinition/schema.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  baseEndpoint = '/assistant/assistant-definitions';

  async update(
    assistantDefinitionId: string,
    values: UpdateValues
  ): Promise<PopulatedAssistantDefinition> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${assistantDefinitionId}`);
    return await this.common.patchJSON(url, values);
  }

  async getOneById(assistantDefinitionId: string): Promise<PopulatedAssistantDefinition> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${assistantDefinitionId}`);
    return await this.common.getJSON(url);
  }
}
